import React from 'react';
import PropTypes from 'prop-types';

import {FormInline, CheckboxInput} from '../../../fragments/forms';
import Button from '../../../fragments/button';
import SelectControl from '../../../fragments/select-control';

import {
  PHENOTYPE_METHOD,
  NRTI_NNRTI, PI, INSTI, CAI,
  IC_VALUES,
} from '../../../../constants';


function build_options(option_list) {
  return option_list.map((value) => ({
    value: value,
    label: value
  }));
}


export default class UpdateButton extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
    onAddColumn: PropTypes.func.isRequired,
    onUpdateColumn: PropTypes.func.isRequired,
    onCheck: PropTypes.func.isRequired,
  };

  constructor() {
    super(...arguments);
    this.state = {
      PR: {
        options: build_options(PI),
        choice: '',
        prompt: "PR Inhibitor ...",
        show: false,
      },
      RT: {
        options: build_options(NRTI_NNRTI),
        choice: '',
        prompt: "RT Inhibitor ...",
        show: false,
      },
      IN: {
        options: build_options(INSTI),
        choice: '',
        prompt: "IN Inhibitor ...",
        show: false,
      },
      CA: {
        options: build_options(CAI),
        choice: '',
        prompt: "CA Inhibitor ...",
        show: false,
      },
      choice: null,
      IC: {
        options: build_options(IC_VALUES),
        choice: '',
        prompt: 'Choose IC',
      },
      method: {
        options: build_options(PHENOTYPE_METHOD),
        choice: '',
        prompt: "Choose phenotype method",
      },
      with_ic50_abs_value: false,
    };
  }

  componentDidMount() {
    for (const gene of ['PR', 'RT', 'IN', 'CA']) {
      const gene_config = this.state[gene];
      gene_config.show = true;
      this.setState(gene_config);
    }
  }

  handleChooseDrug(gene) {

    return (e) => {
      e.preventDefault();
      const geneContext = this.state[gene];
      geneContext.choice = e.target.value;
      this.setState({
        choice: e.target.value,
      });
      for (let g of ['RT', 'PR', 'IN', 'CA']) {
        if (g !== gene) {
          this.setDrugSelDefault(g);
        }
      }
    };
  }

  setDrugSelDefault(gene) {
    let geneContext = this.state[gene];
    geneContext.choice = '';
    this.setState({
      gene: geneContext
    });
  }

  handleChooseMethod(e) {
    const {method} = this.state;
    method.choice = e.target.value;
    this.setState({
      method,
    });
  }

  handleChooseIC(e) {
    const {IC} = this.state;
    IC.choice = e.target.value;
    this.setState({IC});
  }

  async handleUpdateColumn() {
    const {onUpdateColumn} = this.props;
    const {method} = this.state;
    if (method.choice) {
      await onUpdateColumn('Method', method.choice);
    }

    const {IC} = this.state;
    if (IC.choice) {
      await onUpdateColumn('IC', IC.choice);
    }
  }

  async handleAddColumn() {
    const {choice} = this.state;
    if (choice) {
      const {onAddColumn} = this.props;
      await onAddColumn(choice);
    }
    this.setState({with_ic50_abs_value: false});
    for (var gene of ['RT', 'PR', 'IN', 'CA']) {
      this.setDrugSelDefault(gene);
    }
  }

  handleOnCheck(value) {
    const {onCheck} = this.props;
    this.setState({with_ic50_abs_value: value});
    onCheck(value);
  }

  render() {
    const {
      RT, PR, IN, CA,
      IC,
      method,
    } = this.state;
    return (
      <div>
        <div>
          <FormInline dom="span">
            <SelectControl
             options={method.options}
             value={method.choice}
             prompt={method.prompt}
             onChange={this.handleChooseMethod.bind(this)} />
          </FormInline>&nbsp;
          <FormInline dom="span">
            <SelectControl
             options={IC.options}
             value={IC.choice}
             prompt={IC.prompt}
             onChange={this.handleChooseIC.bind(this)} />
          </FormInline>&nbsp;
          <FormInline dom="span">
            <Button
             btnStyle="default"
             onClick={
              this.handleUpdateColumn.bind(this)}>
              Update
            </Button>
          </FormInline>
        </div>
        <br/>
        <div>
          <span>
            Add phenotype fold for:{' '}
          </span>
        </div>
        <div>
          {RT.show? <FormInline dom="span">
            <SelectControl
             options={RT.options}
             value={RT.choice}
             prompt={RT.prompt}
             onChange={this.handleChooseDrug('RT')} />
          </FormInline> : null}&nbsp;
          {PR.show? <FormInline dom="span">
            <SelectControl
             options={PR.options}
             value={PR.choice}
             prompt={PR.prompt}
             onChange={this.handleChooseDrug('PR')} />
          </FormInline> : null}&nbsp;
          {IN.show? <FormInline dom="span">
            <SelectControl
             options={IN.options}
             value={IN.choice}
             prompt={IN.prompt}
             onChange={this.handleChooseDrug('IN')} />
          </FormInline> : null}&nbsp;
          {CA.show? <FormInline dom="span">
            <SelectControl
             options={CA.options}
             value={CA.choice}
             prompt={CA.prompt}
             onChange={this.handleChooseDrug('CA')} />
          </FormInline> : null}&nbsp;
          <CheckboxInput
           name="results"
           checked={this.state.with_ic50_abs_value}
           onChange={
              this.handleOnCheck.bind(this)}>
            with IC50 absolute value
          </CheckboxInput>

          <span>
            <Button
             btnStyle="default"
             onClick={
              this.handleAddColumn.bind(this)}
            >
              Add
            </Button>
          </span>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/susc-results/gtable/update-button.js